const ERROR = {
    PRIMARY_COMPANY_NOT_FOUND: {
        code: 'PRIMARY_COMPANY_NOT_FOUND',
        message: ''
    }
}

export default ERROR